import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid px-0 main-wrapper" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  class: "collapse navbar-collapse d-md-flex justify-content-md-end",
  id: "navbarText"
}
const _hoisted_4 = {
  class: "navbar-nav mb-2 mb-lg-0",
  style: {"margin-right":"6.5px"}
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-md navbar-primary navbar-light bg-white mx-auto pt-md-4 mb-md-4 pxmd-2 col-lg-10 p-0", { 'navbar-drop': _ctx.showAdminBar }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "navbar-brand skin-navbar-brand p-0",
        target: "_blank",
        href: _ctx.parentCompanyLink,
        style: _normalizeStyle(_ctx.parentCompanyLink === '' ? 'pointer-events: none;' : '')
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "visually-hidden" }, "Guiide", -1)
      ]), 12, _hoisted_2),
      _cache[7] || (_cache[7] = _createElementVNode("button", {
        class: "navbar-toggler border-0 fs-6",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarText",
        "aria-controls": "navbarText",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_ctx.navVisible)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Home")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: "/integration",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Guided Drawdown")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: "/faq",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("FAQ's")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/media",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Media")
                    ])),
                    _: 1
                  })
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("li", { class: "nav-item" }, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: "https://guiidewordpress.azurewebsites.net/"
                  }, "Blog")
                ], -1)),
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Log In")
                    ])),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}